export class SchemaAttribute {
  constructor(
      public id: string,
      public attributeName: string,
      public nameTranslations: any
  ){}
}
